import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { navigateToLoginScreen } from '../pages/PageProfile';

export default function AlertDialog(props) {

  const login = () => { navigateToLoginScreen() }

  return (
    <div className="loginAlert">
      <Dialog
        open={props.open}
        onClose={() => { props.closeAlertBox() }}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        {/* <DialogTitle id="alert-dialog-title">
          {""}
        </DialogTitle> */}
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {props.loginAlertMessage}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => { props.closeAlertBox() }}>Cancel</Button>
          <Button onClick={login} autoFocus>
            Login to Continue
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
